import angular from 'angular';
// import pqrsComponent from './pqrs.component';
// import ContactService from './pqrs.service';
// import pqrsConfig from './pqrs.config';
import pqrsListModule from './pqrs-list/pqrs-list';
import pqrsDetailModule from './pqrs-detail/pqrs-detail';
import PqrsFormModalController from './pqrs-form-modal/pqrs-form-modal.controller';

let pqrsModule = angular.module('app.pqrs',[
  pqrsListModule.name,
  pqrsDetailModule.name
])
  .controller('PqrsFormModalController', PqrsFormModalController);
export default pqrsModule;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/pqrs/pqrs.js
 **/